import { useTranslation } from 'react-i18next';
import { Skill } from './types';
import RingChart from './RingChart';
import styles from './Skills.module.scss';

const CoreCard = ({ skill }: { skill: Skill }) => {
  const { t } = useTranslation();
  return (
    <>
      <p className={styles.coreTag}>{t('skills.coreTag')}</p>
      <h3 className={styles.name}>{skill.name}</h3>
      <RingChart level={skill.level} />
    </>
  );
};

export default CoreCard;
